/** PipelineRoute — entry for /pipeline.
 *  Pipeline owns its own CockpitPage + CockpitMasthead (with hero metrics
 *  and action buttons), so we render it directly in both skins.
 *  Wrapping it in CockpitFrame would duplicate the "Pipeline" header. */
import Pipeline from "./Pipeline";

export default function PipelineRoute() {
  return <Pipeline />;
}
